export class AppEvent {
  static APP_STATE_CHANGE = 'APP_STATE_CHANGE';
  static MOBILE_STATE_CHANGE = 'MOBILE_STATE_CHANGE';
  static NEW_ARTICLE_CATEGORY = 'NEW_ARTICLE_CATEGORY';
  static SAVE_ARTICLE_ITEM = 'SAVE_ARTICLE_ITEM';
  static EDIT_ARTICLE_ITEM = 'EDIT_ARTICLE_ITEM';
  static SHOW_LOGIN_FROM_STATIC_ARTICLE = 'SHOW_LOGIN_FROM_STATIC_ARTICLE';
  static USER_HAS_BEEN_LOGGED = 'USER_HAS_BEEN_LOGGED';
  static USER_NOT_LOGGED = 'USER_NOT_LOGGED';
  static USER_SELECTED = 'USER_SELECTED';
  static SELECTED_USER_LOADED = 'SELECTED_USER_LOADED';
  static OTHER_USER_ACTION = 'OTHER_USER_ACTION';
  static USER_EDIT_START_ACTION = 'USER_EDIT_START_ACTION';
  static USER_BOOKINGS_START_ACTION = 'USER_BOOKINGS_START_ACTION';
  static FRIEND_INVITE_START_ACTION = 'FRIEND_INVITE_START_ACTION';
  static GROUP_ADD_START_ACTION = 'GROUP_ADD_START_ACTION';
  static SHOW_FRESH_RELATIONS = 'SHOW_FRESH_RELATIONS';
  static CLASS_SELECTED = 'CLASS_SELECTED';
  static CLASS_CHECKED = 'CLASS_CHECKED';
  static CLASS_EVENT_ADDED = 'CLASS_EVENT_ADDED';
  static COMMUNITY_CLASS_ADDED = 'COMMUNITY_CLASS_ADDED';
  static COMMUNITY_CLASS_UPDATED = 'COMMUNITY_CLASS_UPDATED';
  static COMMUNITY_CLASS_DELETED = 'COMMUNITY_CLASS_DELETED';
  static ADD_TRAINER_SCHEDULE = 'ADD_TRAINER_SCHEDULE';
  static ADD_SCHEDULE = 'ADD_SCHEDULE';
  static ADD_BASIC_SCHEDULE = 'ADD_BASIC_SCHEDULE';
  static SAVE_PROFILE = 'SAVE_PROFILE';
  static CLASS_MENU_EVENT = 'CLASS_MENU_EVENT';
  static SCHEDULE_ADDED = 'SCHEDULE_ADDED';
  static SCHEDULE_UPDATED = 'SCHEDULE_UPDATED';
  static GAME_CREATED = 'GAME_CREATED';
  static EVENT_DELETED = 'EVENT_DELETED';
  static EVENT_UPDATED = 'EVENT_UPDATED';
  static MUTUAL_CUP_GAME_CHANGE = 'MUTUAL_CUP_GAME_CHANGE';
  static CUP_PLAYER_STATUS_CHANGED = 'CUP_PLAYER_STATUS_CHANGED';
  static CUP_PLAYER_GAME_STATUS_CHANGED = 'CUP_PLAYER_GAME_STATUS_CHANGED';
  static CUP_PLAYER_VIEW_OPEN = 'CUP_PLAYER_VIEW_OPEN';
  static DRAGGER_USERS_LOADING = 'DRAGGER_USERS_LOADING';
  static DRAGGER_USERS_LOADED = 'DRAGGER_USERS_LOADED';
  static DRAGGER_USERS_ERROR = 'DRAGGER_USERS_ERROR';
  static DRAGGER_USER_CHANGE = 'DRAGGER_USER_CHANGE';
  type: string;
  data: object;
  canceled: boolean;

  constructor(type: string, data: object) {
    this.type = type;
    this.data = data;
  }
}
